import styled from "styled-components";

const padding = ({ size }) => {
  switch (size) {
    case "xs":
      return "8px";
    case "lg":
      return "16px";

    case "sm":
    case "md":
    default:
      return "12px";
  }
};

const fontSize = ({ size }) => {
  switch (size) {
    case "xs":
      return "12px";
    case "sm":
      return "14px";
    case "lg":
      return "20px";

    case "md":
    default:
      return "16px";
  }
};

const borderRadius = ({ prefix, suffix }) => {
  if (prefix) return "8px 0 0 8px";
  if (suffix) return "0 8px 8px 0";

  return "8px";
};

export const Wrapper = styled.div`
  display: grid;
  place-items: center;
  padding: ${padding};
  border-radius: ${borderRadius};
  font-size: ${fontSize};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  line-height: 24px;
  color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
  background-color: ${({ theme, disabled }) => {
    if (disabled) return theme.colors.neutral.gray2;

    return theme.colors.neutral.gray1;
  }};
  cursor: ${({ onClick }) => (onClick ? "pointer" : "auto")};
`;
